/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="15.12"
        height="19.14"
        viewBox="0 0 15.12 19.14"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M2.79 4.95v2.06H0v12.13h15.12V7.01h-2.74V4.95a4.8 4.8 0 1 0-9.59 0Zm11.33 3.06v10.13H1V8.01Zm-2.74-3.06v2.06H3.79V4.95a3.8 3.8 0 1 1 7.59 0ZM7.6 15.5a2.35 2.35 0 0 0 1.66-4 2.32 2.32 0 0 0-2.56-.51 2.35 2.35 0 0 0 .9 4.53Zm0-3.71a1.36 1.36 0 1 1-.52 2.61 1.36 1.36 0 0 1 .52-2.61Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'LockIcon';

export default Icon;
